import { IconButton } from '@components/icon-button';
import { IconMoreVertical } from '@components/icons/more-vertical';
import { Menu } from '@components/menu';

import { TravellerJourney, TravellerJourneyListItem } from 'api/types';

import { useTravellerActions } from '../travellers/list';

type TravellerOptionsMenuProps = { row: TravellerJourney | TravellerJourneyListItem };

export const TravellerOptionsMenu = ({ row: traveller }: TravellerOptionsMenuProps) => {
  const travellerOptions = useTravellerActions(traveller);
  return (
    <Menu
      trigger={IconButton}
      triggerProps={{ variant: 'ghost-purple', size: 'md', icon: <IconMoreVertical /> }}
    >
      {travellerOptions.map((option, index) => {
        if (option === 'separator') {
          return <Menu.Separator key={`separator-${index}`} />;
        }
        const { onSelect, isDisabled, tooltip, ...rest } = option;
        return (
          <Menu.Item
            key={rest.label}
            {...rest}
            isDisabled={isDisabled?.(traveller)}
            tooltip={tooltip?.(traveller)}
            onSelect={() => onSelect(traveller)}
          />
        );
      })}
    </Menu>
  );
};
